
import React, { useEffect, useState, useRef, lazy } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter, Routes, Route , useLocation } from "react-router-dom";
import OrderView from "./pages/OrderView";
import NewProduct from "./Admin/NewProduct";
import BuySell from "./pages/BuySell";
import AddInventory from "./Admin/Invertory/AddInventory";
import OrderDetail from "./Admin/Order/OrderDetail";
import CustomerMain from "./Admin/Customer/CustomerMain";
import CustomerDetail from "./Admin/Customer/CustomerDetail";
import GraphicTab from "./components/GraphicTab";
import AdminUi from "./Layout/AdminUi";
import UseUi from "./Layout/UseUi";
import Home from "./pages/home/Home";
import Categories from "./pages/categories";
import Product from "./pages/Product";
import Bidask from "../src/pages/bidask";
import BuySellManagment from "./pages/BuySellManagment";
import "react-toastify/dist/ReactToastify.css";
import UserBuySell from "./components/UserBuySell";
import Compare from "./components/Compare";
import FavouriteList from "./components/FavouriteList";
import Blanck from "./components/Blanck";
import ForgotPassword from "./components/ForgotPassword";
import Tooltip from "./components/Tooltip";
import ResetPassword from "./components/ResetPassword";
import TermCondition from "./components/TermCondition";
import OrderConfirmation from "./components/OrderConfirmation";
import PrivacyPolicy from "./components/PrivacyPolicy";
import NewProfile from "./components/NewProfile";
import PackageSlip from "./components/PackageSlip";
import StripeAccount from "./Admin/Customer/StripeAccount";
import Shipping from "./Admin/Customer/Shipping";
import Banner from "./components/Banner";
import { AuthProvider } from "./context/UserContext";
import PendingTable from "./components/PendingTable";
import HistoryTable from "./components/HistoryTable";
import ShippingDescriptions from "./pages/ShippingDescriptions";
import CreateTopic from "./Admin/HelpData/Topic/CreateTopic";
import TopicList from "./Admin/HelpData/Topic/TopicList";
import CreateCategory from "./Admin/HelpData/Category/CreateCategory";
import CategoryList from "./Admin/HelpData/Category/CategoryList";
import Help from "./pages/Help/Help";
import ExportApi from "./api/ExportApi";
import Threshold from "./Admin/Threshold/Threshold";
import SellerOrder from "./Admin/SellerOrder/SellerOrder";
import AboutUs from "./pages/About/index";
import Globaldescription from "./Admin/Globaldescription";
import News from "../src/pages/News/News";
import List from "./pages/Listpage/List";
import AdminNews from "./Admin/News/Adminnews";
import AdminNewsList from "./Admin/News/Newslist";
import Cookiepolicy from "./components/Cookiepolicy";
import Singlenews from "./pages/Listpage/viewnews";
import Customerview from "./Admin/Customer/Customerview";
import Updatebulkprice from "./components/Updatebulkprice";
import G2fa from "./Admin/Gauth/g2fa";
import G2auth from "./components/G2auth";
import { checkSessionExpiry, updateActivityTime } from "./sessionUtils";
import OrderBook from "./Admin/OrderBook/OrderBook";
import EditComponent from "./Admin/News/EditComponent";
import SEO from "./Admin/SeoTags/Seo";
import { HelmetProvider } from "react-helmet-async";
import Productseotags from "./Admin/Productseo/productseotags";
import TawkMessengerReact from "@tawk.to/tawk-messenger-react";
import ShipmentLogs from "./Admin/Shippo/Shipmentapilogs";
import { Provider } from "react-redux";
import store from "./redux/store";
import { useDispatch } from "react-redux";
import { fetchFilters } from "./redux/Slices/filterSlice";
import NewSell from "./pages/newSell";
import Affiliates from "./Admin/Affiliates/affiliateList";
import TrackingLogs from "./Admin/Affiliates/trackingLogs";
import { useAuthUser } from "./customHooks/useAuthUser";
import AffiliateOrders from "./Admin/Affiliates/affiliateOrders";
import SetupPayout from "./pages/setupPayout";
import ManageAlertsDashBoard from "./components/priceAlerts/manageAlertDashboard";
import SendMarketingEmail from "./components/sendMarketingMail";


const Main = () => {
  const [searchValue, setSearchValue] = useState();
  const [seoData, setSeoData] = useState([]);

  const loggedInUser =  useAuthUser();

  useEffect(() => {
    if (window.location.hostname !== "001.gpuwiz.com") return;

    const isAuthenticated = localStorage.getItem("devAuthenticated");

    // If already authenticated → do nothing
    if (isAuthenticated === "true") return;

    // Ask only if NOT authenticated
    const enteredPassword = prompt("Enter access password to view the site:");
    const correctPassword = "E123QWERFG**";

    if (enteredPassword === correctPassword) {
      localStorage.setItem("devAuthenticated", "true");
    } else {
      alert("Incorrect password");
      window.location.reload();
    }
  }, []);

  const tawkMessengerRef = useRef();

const onLoad = () => {
  console.log("Tawk widget has loaded");
};
 
  setInterval(() => {
    const loginTime = localStorage.getItem("loginTime");

    if (loginTime) {
      checkSessionExpiry();
      const handleActivity = () => {
        updateActivityTime();
      };

      // Event listeners for detecting user activity
      // window.addEventListener('mousemove', handleActivity);
      window.addEventListener("keypress", handleActivity);
      window.addEventListener("click", handleActivity);

      // Periodic check for session expiry
      const sessionCheckInterval = setInterval(() => {
        checkSessionExpiry();
      }, 1000);
      return () => {
        window.removeEventListener("mousemove", handleActivity);
        window.removeEventListener("keypress", handleActivity);
        window.removeEventListener("click", handleActivity);
        clearInterval(sessionCheckInterval);
      };
    } else {
    }
  }, 1000);

  useEffect(() => {
    const fetchSeoData = async () => {
      try {
        const resp = await ExportApi.getSeoDataall();
        //console.log("SEO Data Fetched:", resp?.data?.data);
        setSeoData(resp?.data?.data);
      } catch (error) {
        console.error("Error fetching SEO data:", error);
      }
    };

    fetchSeoData();
  }, []);

  const homeSeoData = seoData?.find((item) => item?.page === "Home") || {};
  const userBuySellseo =
    seoData?.find((item) => item?.page === "UserBuySell") || {};
  const Aboutseo = seoData?.find((item) => item?.page === "About") || {};
  const Newsseo = seoData?.find((item) => item?.page === "News") || {};
  const Helpseo = seoData?.find((item) => item?.page === "Help") || {};
  const categorySeo = seoData?.find((item) => item?.page === "Categories") || {};


    const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchFilters());
  }, []);


  useEffect(() => {
    const keys = [
      "utm_source",
      "utm_medium",
      "utm_campaign",
      "utm_term",
      "utm_content",
      "gclid",
      "fbclid",
      "ttclid"
    ];

    const url = new URLSearchParams(window.location.search);

    // Load old values (if any)
    const existing = JSON.parse(localStorage.getItem("utm_attribute")) || {};
    const updated = { ...existing };

    keys.forEach((key) => {
      const value = url.get(key);
      if (value) {
        updated[key] = value; // save new utm
      } else if (!updated[key]) {
        updated[key] = null; // ensure all keys exist
      }
    });

    // Save back to localStorage as a single object
    localStorage.setItem("utm_attribute", JSON.stringify(updated));

  }, []);


useEffect(() => {
  // get the refCode from the URL
  const params = new URLSearchParams(window.location.search);
  const refCode = params.get("ref");

  if (!refCode) return;

  // Fetch all affiliates
  const getAllAffiliate = async () => {
    try {
      const resp = await ExportApi.getAffiliates();
      const data = resp.data;

      if (data?.success) {

        // Find matching affiliate object
        const matchedAffiliate = data?.data.find(
          (affiliate) => affiliate.code === refCode
        );

        if (!matchedAffiliate) {
          return;
        }

        // Valid refCode handle for loggedInUser
        if (loggedInUser) {

          ExportApi.attachAffiliateToUser({
            userId: loggedInUser?.id,
            affiliate_id: matchedAffiliate?._id,
          }).catch(err => console.log("Error attaching affiliate:", err));

        }
      } else {
        toast.error(data?.message || "Error fetching affiliates");
      }
    } catch (err) {
      console.log(err);
      toast.error("Error fetching affiliates");
    }
  };

  getAllAffiliate();
}, []);



  const EventTracker = () => {

    const location = useLocation();

    useEffect(() => {
      const trackUserVisit = async () => {
        try {
          // get the ref code from the URL.
          const params = new URLSearchParams(window.location.search);
          const refCode = params.get("ref");
          const visitedURL = window.location.href;
          const deviceType = /Mobi|Android/i.test(navigator.userAgent)
            ? "mobile"
            : "desktop";

          if (refCode) {
            // get all the ref from the db
            const resp = await ExportApi.getAffiliates();
            const data = resp.data;

            if (data?.success) {

              // get the affiliate which is matching the refcode
              const matchedAffiliate = data?.data.find(
                (affiliate) => affiliate.code === refCode
              );

              // if not matching return
              if (!matchedAffiliate) {
                return;
              }

              const affiliateData = {
                affiliate_code: matchedAffiliate.code,
                affiliate_id: matchedAffiliate?._id,
                affiliate_seen_at: new Date().toISOString(), // UTC time
              };

              localStorage.setItem(
                "affiliate_attribution",
                JSON.stringify(affiliateData)
              );

              // Call the tracking API
              await ExportApi.userVisitLog({
                affiliateId: matchedAffiliate?._id,
                deviceType,
                userId: loggedInUser?.id || null,
                visitedURL
              });

            }
            else {
              console.log("Affiliate not found for refCode:", refCode);
              return;
            }
          }
          else {
            // 🔹 ELSE: get affiliate from localStorage
            const storedAffiliate = localStorage.getItem("affiliate_attribution");
            if (!storedAffiliate) {
              // No affiliate, skip tracking
              return;
            }

            const affiliateData = JSON.parse(storedAffiliate);
            const affiliateId = affiliateData?.affiliate_id;
            if (!affiliateId) return;

            // Call the tracking API with stored affiliate
            await ExportApi.userVisitLog({
              affiliateId,
              deviceType,
              userId: loggedInUser?.id || null,
              visitedURL
            });
          }
        } catch (error) {
          console.error("User visit tracking failed:", error);
        }
      };

      trackUserVisit();


      // Cleanup: remove affiliate data when user leaves the site
      const handleUnload = () => {
        localStorage.removeItem("affiliate_attribution");
      };

      window.addEventListener("beforeunload", handleUnload);

      return () => {
        window.removeEventListener("beforeunload", handleUnload);
      };

    }, [location.pathname]);
    return null;
  }

  return (
    <HelmetProvider>
      <TawkMessengerReact
        propertyId="6583dce370c9f2407f8220c3"
        widgetId="1hi5hdmtr"
        onLoad={onLoad}
        ref={tawkMessengerRef}
      />

      <AuthProvider>
        <BrowserRouter>
          <EventTracker />
          <Routes>
            <Route path="/" element={<Home seoData={homeSeoData} />} />
            <Route path="/forgot" element={<ForgotPassword />} />
            <Route path="/reset/:id" element={<ResetPassword />} />
            <Route path="/error" element={<Blanck />} />
            <Route path="/tooltip" element={<Tooltip />} />
            <Route path="/bidask/:slug" element={<Bidask />} />
            <Route path="/bidask/:slug/:buy" element={<Bidask />} />
            <Route
              path="/userBuySell"
              element={<UserBuySell seoData={userBuySellseo} />}
            />
             <Route
              path="/sell"
              element={<NewSell />}
            />
            <Route path="/compareBuySell" element={<Compare />} />
            <Route path="/categories/:slug" element={<Categories seoData={categorySeo} />} />
            <Route path="/categories/:slug/:name" element={<Categories />} />
            <Route path="/OrderDetail/:id" element={<OrderDetail />} />
            <Route path="/product/:slug" element={<Product />} />
            <Route path="/terms" element={<TermCondition />} />
            <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
            <Route path="/cookies" element={<Cookiepolicy />} />
            <Route path="/order" element={<OrderConfirmation />} />

            <Route path="/help" element={<Help seoData={Helpseo} />} />
            <Route path="/help/:slug" element={<Help seoData={Helpseo} />} />
            <Route path="/about" element={<AboutUs seoData={Aboutseo} />} />
            <Route path="/news" element={<News />} />
            <Route path="/list" element={<List seoData={Newsseo} />} />
            <Route path="/news/:id" element={<Singlenews />} />
            <Route path="/setup-payout" element={<SetupPayout />} />

            {/* Start admin layout */}
            <Route path="/" element={<AdminUi />}>
              <Route path="/buySell" element={<BuySell />} />
              <Route path="/orderView" element={<OrderView />} />
              <Route path="/createproduct" element={<NewProduct />} />
              <Route
                path="/globaldescription"
                element={<Globaldescription />}
              />
              <Route path="/productlist" element={<GraphicTab />} />
              <Route path="/bulkpriceupdate" element={<Updatebulkprice />} />
              <Route path="/products/seotags" element={<Productseotags />} />
              <Route path="/addInventory/:id" element={<AddInventory />} />
              <Route path="/customerMain" element={<Customerview />} />
              <Route path="/affiliates" element={<Affiliates />} />
               <Route path="/tracking-logs" element={<TrackingLogs />} />
               <Route path="/affiliate-orders" element={<AffiliateOrders />} />
              <Route path="/customerDetail/:id" element={<CustomerDetail />} />
              <Route path="/shipping" element={<Shipping />} />
              <Route path="/banner" element={<Banner />} />
              <Route path="/marketing-mail" element={<SendMarketingEmail />} />
              <Route
                path="/shipping-descriptions"
                element={<ShippingDescriptions />}
              />
              <Route path="/house-pending" element={<PendingTable />} />
              <Route path="/house-history" element={<HistoryTable />} />
              <Route path="/admin/create-topic" element={<CreateTopic />} />
              <Route path="/admin/topic-list" element={<TopicList />} />
              <Route
                path="/admin/create-category"
                element={<CreateCategory />}
              />
              <Route path="/admin/category-list" element={<CategoryList />} />
              <Route path="/admin/threshold" element={<Threshold />} />
              <Route path="/admin/2fa" element={<G2fa />} />
              <Route path="/admin/seo" element={<SEO />} />
              <Route path="/admin/sellerorder" element={<SellerOrder />} />
              <Route path="/admin/orderbook" element={<OrderBook />} />

              <Route path="/admin/shipporates/apilogs" element={<ShipmentLogs />} />

              <Route path="/adminnews" element={<AdminNews />} />
              <Route path="/admin/editnews/:id" element={<EditComponent />} />
              <Route path="/adminnewslist" element={<AdminNewsList />} />
            </Route>
            <Route path="/" element={<UseUi />}>
              <Route
                path="/buySellManagment/selling"
                element={<BuySellManagment />}
              />
              <Route
                path="/buySellManagment/buying"
                element={<BuySellManagment />}
              />
              <Route path="/profile/:id" element={<NewProfile />} />
              <Route path="/profile" element={<NewProfile />} />
              <Route path="/g2fa" element={<G2auth />} />

              <Route
                path="/stripeconnectaccount/:id"
                element={<StripeAccount />}
              />
              <Route path="/package" element={<PackageSlip />} />
              <Route
                path="/buySellManagment/pending"
                element={<BuySellManagment />}
              />
              <Route
                path="/buySellManagment/history"
                element={<BuySellManagment />}
              />
              <Route
                path="/buySellManagment/setting"
                element={<BuySellManagment />}
              />
              <Route
                path="/buySellManagment/favorites"
                element={<FavouriteList />}
              />
               <Route
                path="/buySellManagment/manage-alerts"
                element={<ManageAlertsDashBoard />}
              />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </HelmetProvider>
  );
};
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <Main />
  </Provider>
);
reportWebVitals();
